import React from 'react'

const Result: React.FC = () => {
    return (
        <div>Result</div>
    )
}

export default Result